import ProviderStatisticsContainer from './provider-statistics-container';

export default ProviderStatisticsContainer;
